/* ag-admin-discount-codes.js, wires the AG-Admin-Discount-Codes section
 * to the tmb-script /exec backend. Auth + AG_ADMIN.api are provided by
 * AG-Admin-Shell (assets/ag-admin.js). */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }

  function formatDate(v) {
    if (!v) return '';
    var d = (v instanceof Date) ? v : new Date(v);
    if (isNaN(d.getTime())) return String(v);
    var y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function renderTable(rows) {
    var tbody = $('#agdc-tbody');
    if (!tbody) return;
    if (!rows || !rows.length) {
      tbody.innerHTML = '<tr class="empty"><td colspan="7">No codes minted yet.</td></tr>';
      return;
    }
    var html = rows.map(function (r) {
      // Defensive: Discount Codes tab column shape from
      // tmb-shopify-discount.js → Code, Percent, MaxUses, Customer Email,
      // Expires At, Created At, Title, Shopify Code ID.
      var code = r['Code'] || r.code || '';
      var pct = r['Percent'] || r.percent || '';
      var email = r['Customer Email'] || r.customerEmail || '';
      // Sheet headers (per tmb-shopify-discount.js logDiscountCode_):
      // Code | Minted | Percent | Product GID | Customer Email | Max Uses | Expires | Admin URL
      var max = r['Max Uses'] || r.maxUses || '';
      var expires = r['Expires'] || r.expiresAt || '';
      var created = r['Minted'] || r.createdAt || '';
      var used = (r.usedCount != null) ? r.usedCount : '';
      var usesLabel = (used !== '' ? (used + ' / ' + max) : String(max || '∞'));
      return '<tr>' +
        '<td class="code">' + escapeHtml(String(code)) + '</td>' +
        '<td>' + escapeHtml(String(pct)) + '%</td>' +
        '<td>' + escapeHtml(String(email || '-')) + '</td>' +
        '<td>' + escapeHtml(usesLabel) + '</td>' +
        '<td>' + escapeHtml(formatDate(expires)) + '</td>' +
        '<td>' + escapeHtml(formatDate(created)) + '</td>' +
        '<td><button type="button" class="agdc-del" data-code="' + escapeHtml(String(code)) + '">Delete</button></td>' +
      '</tr>';
    }).join('');
    tbody.innerHTML = html;
    wireDeleteButtons();
  }

  function wireDeleteButtons() {
    var btns = document.querySelectorAll('#agdc-tbody .agdc-del');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', onDeleteClick);
    }
  }

  async function onDeleteClick(e) {
    var btn = e.currentTarget;
    var code = btn.getAttribute('data-code') || '';
    if (!code) return;
    if (!window.confirm('Delete code ' + code + ' from Shopify? This is permanent.')) return;
    btn.disabled = true;
    var prevLabel = btn.textContent;
    btn.textContent = 'Deleting...';
    try {
      await window.AG_ADMIN.api('admin_deleteDiscount', { code: code });
      // Optimistic: drop the row from the DOM right away.
      var tr = btn.closest('tr');
      if (tr) tr.remove();
    } catch (e2) {
      btn.disabled = false;
      btn.textContent = prevLabel;
      window.alert('Delete failed: ' + (e2 && e2.message || e2));
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* Stale-while-revalidate cache for the codes list. Persists for
     2 hours in localStorage so reopening the page paints instantly
     while a background refresh runs. */
  var AGDC_CACHE_KEY = 'agdc:codes-cache:v1';
  function readCachedCodes() {
    try {
      var raw = localStorage.getItem(AGDC_CACHE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || !p.savedAt || Date.now() - p.savedAt > 2 * 3600 * 1000) return null;
      return p.codes || [];
    } catch (_) { return null; }
  }
  function writeCachedCodes(codes) {
    try { localStorage.setItem(AGDC_CACHE_KEY, JSON.stringify({ savedAt: Date.now(), codes: codes })); } catch (_) {}
  }
  function setRefreshingPip(on) {
    var existing = document.getElementById('agdc-refreshing-pip');
    if (existing) existing.remove();
    if (!on) return;
    var msg = $('#agdc-msg');
    if (!msg) return;
    var pip = document.createElement('span');
    pip.id = 'agdc-refreshing-pip';
    pip.style.cssText = 'margin-left:8px;font-size:11px;opacity:0.7;';
    pip.textContent = 'refreshing…';
    msg.appendChild(pip);
  }
  async function loadCodes() {
    var tbody = $('#agdc-tbody');
    var cached = readCachedCodes();
    if (cached && cached.length) {
      renderTable(cached);
      setRefreshingPip(true);
    } else if (tbody) {
      tbody.innerHTML = '<tr class="empty"><td colspan="6">Loading...</td></tr>';
    }
    try {
      var r = await window.AG_ADMIN.api('admin_listDiscounts', { limit: 30 });
      var codes = (r && r.codes) || [];
      writeCachedCodes(codes);
      renderTable(codes);
    } catch (e) {
      if (!cached && tbody) tbody.innerHTML = '<tr class="empty"><td colspan="6">Failed to load: ' + escapeHtml(String(e && e.message || e)) + '</td></tr>';
    } finally {
      setRefreshingPip(false);
    }
  }

  function showMsg(text, ok) {
    var el = $('#agdc-msg');
    if (!el) return;
    el.textContent = text;
    el.className = 'agdc-msg ' + (ok ? 'ok' : 'err');
  }

  function clearMsg() {
    var el = $('#agdc-msg');
    if (el) { el.textContent = ''; el.className = 'agdc-msg'; }
  }

  function readForm() {
    return {
      percent:             Number($('#agdc-percent').value),
      prefix:              ($('#agdc-prefix').value || '').trim(),
      customerEmail:       ($('#agdc-email').value || '').trim(),
      maxUses:             Number($('#agdc-maxuses').value),
      expiresInDays:       Number($('#agdc-expires').value),
      recurringCycleLimit: Number($('#agdc-cycles').value),
    };
  }

  async function handleSubmit(e) {
    e.preventDefault();
    clearMsg();
    var btn = $('#agdc-submit');
    btn.disabled = true; btn.textContent = 'Minting...';
    try {
      var payload = readForm();
      var r = await window.AG_ADMIN.api('admin_mintDiscount', payload);
      var code = (r && r.result && r.result.code) || '';
      if (!code) throw new Error('No code returned');
      showMsg('Minted: ' + code, true);
      var msgEl = $('#agdc-msg');
      if (msgEl) {
        msgEl.innerHTML = 'Minted: <span class="agdc-code-out">' + escapeHtml(code) + '</span>';
        msgEl.className = 'agdc-msg ok';
      }
      loadCodes();
    } catch (e2) {
      showMsg('Failed: ' + (e2 && e2.message || e2), false);
    } finally {
      btn.disabled = false; btn.textContent = 'Mint code';
    }
  }

  function init() {
    var form = $('#agdc-form');
    if (form) form.addEventListener('submit', handleSubmit);
    var refresh = $('#agdc-refresh');
    if (refresh) refresh.addEventListener('click', loadCodes);
    // Initial load. AG-Admin-Shell calls window.AG_ADMIN_READY after
    // a successful auth ping. Fall back to delayed load if hook missing.
    if (window.AG_ADMIN && window.AG_ADMIN.onReady) {
      window.AG_ADMIN.onReady(loadCodes);
    } else {
      setTimeout(loadCodes, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
